import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';

import { FeatureManagementDirectiveModule } from 'src/app/features/feature-management/directives/feature-management-directive.module';

import {
  BrandingComponent,
  ButtonComponent,
  ButtonContainerComponent,
  CardComponent,
  CloseIconComponent,
  CollapsibleComponent,
  ConfirmationModalComponent,
  InfoBoxComponent,
  InfoIconComponent,
  LinkButtonComponent,
  LoadingTimeoutComponent,
  NeedHelpComponent,
  NotificationsIconComponent,
  PasswordInputComponent,
  PhoneInputComponent,
  SelectInputComponent,
  SessionEndingProgressionComponent,
  SessionStatusSplashComponent,
  SkeletonTextComponent,
  SparkIconComponent,
  StepperComponent,
  SupportComponent,
  SupportPhoneComponent,
  TextAreaInputComponent,
  TextInputComponent,
  AlertBannerComponent,
  AlertBannerExpandComponent,
} from './components';
import {
  DebounceClickDirective,
  DesktopOnlyDirective,
  IconTooltipDirective,
  MobileOnlyDirective,
} from './directives';
import { PhonePipe, SafeHtmlPipe, SafeResourceUrlPipe } from './pipes';
import { MatExpansionModule } from '@angular/material/expansion';

const MaterialModules = [
  MatBadgeModule,
  MatButtonModule,
  MatCheckboxModule,
  MatDividerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSnackBarModule,
  MatTooltipModule,
  MatExpansionModule,
];

const pipes = [PhonePipe, SafeHtmlPipe, SafeResourceUrlPipe];

const directives = [
  DebounceClickDirective,
  DesktopOnlyDirective,
  IconTooltipDirective,
  MobileOnlyDirective,
];

const components = [
  BrandingComponent,
  ButtonComponent,
  ButtonContainerComponent,
  CardComponent,
  CloseIconComponent,
  CollapsibleComponent,
  ConfirmationModalComponent,
  InfoBoxComponent,
  InfoIconComponent,
  LinkButtonComponent,
  LoadingTimeoutComponent,
  NeedHelpComponent,
  NotificationsIconComponent,
  PasswordInputComponent,
  PhoneInputComponent,
  SelectInputComponent,
  SessionEndingProgressionComponent,
  SessionStatusSplashComponent,
  SkeletonTextComponent,
  SparkIconComponent,
  StepperComponent,
  SupportComponent,
  SupportPhoneComponent,
  TextAreaInputComponent,
  TextInputComponent,
  AlertBannerComponent,
  AlertBannerExpandComponent
];

@NgModule({
  declarations: [...pipes, ...directives, ...components],
  imports: [
    CommonModule,
    FeatureManagementDirectiveModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule,
    ...MaterialModules,
  ],
  providers: [PhonePipe, { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher }],
  exports: [
    ...pipes,
    ...directives,
    ...components,
    FeatureManagementDirectiveModule,
    MaterialModules,
  ],
})
export class SharedModule {}
